<!-- eslint-disable @angular-eslint/template/elements-content -->

<div class="gcontainer combine-container" #combinepage>
  <div class="r-header-wrapper">
    <!-- Breadcrumb-->
    <div class="no-print">
      <nav aria-label="breadcrumb" class="bredcrums">
        <ol class="breadcrumb">
          <li class="breadcrumb-item active breadcrumb cursor" aria-current="page">
            <a class="c-primary" [routerLink]="'/dashboard'" tabindex="0"> Dashboard </a>
          </li>
          <li class="breadcrumb-item active" aria-current="page">Combine Project</li>
        </ol>
      </nav>
    </div>
    <!-- Header Title-->
    <div class="row">
      <div class="col-sm-10">
        <h1 class="header-title">Combine Project</h1>
      </div>
    </div>

    <!-- Company Details -->
    <div class="company-wrapper">
      <div class="row">
        <form [formGroup]="companyFormGroup">
          <div class="col-md-12">
            <div class="row">
              <div class="col-2 tile-label">
                <mat-label class="mat-label company-field">Material Type :</mat-label>
              </div>
              <div class="col-3 raido-field">
                <mat-radio-group
                  aria-label="Select an option"
                  color="primary"
                  formControlName="materialType"
                  [disabled]="radiobtndisabled">
                  <mat-radio-button value="nativesoil">Native Soil</mat-radio-button>
                  <mat-radio-button value="precast">Pre Cast</mat-radio-button>
                </mat-radio-group>
              </div>
              <div class="col-7 table-col"></div>
            </div>
          </div>

          <div class="col-md-12">
            <div class="row">
              <div class="col-2 input-label">
                <mat-label class="mat-label form-label company-field">Search Project No:</mat-label>
              </div>
              <div class="col-3 input-field">
                <mat-form-field appearance="outline" class="mat-form-field-width company-field">
                  <input
                    matInput
                    class="search-text"
                    (input)="onSearchChange()"
                    (keypress)="onKeyPress($event)"
                    [(ngModel)]="searchKeyWord"
                    [ngModelOptions]="{ standalone: true }" />
                    @if (searchKeyWord.length > 0) {
                      <mat-icon
                        class="cursor"
                        matSuffix
                        (click)="onClearSearchButtonClick()">
                        close
                      </mat-icon>
                    }
                  </mat-form-field>
                </div>
                @if (sampleCount) {
                  <div class="col-1 search-btn">
                    <div class="btn-wrapper">
                      <div class="no-print btn-container btn-right">
                        <button [disabled]="btnEnabled" mat-raised-button color="primary" (click)="onSearchButtonClick()">
                          Search
                        </button>
                      </div>
                    </div>
                  </div>
                }
                <div class="col-6 table-col"></div>
              </div>
            </div>
          </form>
        </div>
      </div>

      <!-- combine Tables-->

      <div class="table-wrapper">
        <app-add-combine-table
          [headerColumns]="headerColumns"
          [displayedColumns]="displayedColumns"
          [dataSource]="dataSource"
          [soiltype]="soilType"
          (sampleCountExceeded)="handleSampleCountExceeded($event)"
          >
        </app-add-combine-table>


      </div>
    </div>
  </div>
